import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';


/** ************************************************
/* @author Sandra Koo
/* __          ___               _
/* \ \        / / |             | |
/*  \ \  /\  / /| |__   ___  ___| |
/*   \ \/  \/ / | '_ \ / _ \/ _ \ |
/*    \  /\  /  | | | |  __/  __/ |
/*     \/  \/   |_| |_|\___|\___|_|
 ******************************************** */
export default class RequestHelp_Wheel extends Phaser.Group {
  /**
   * config = {
   *  prizeList: Array<{base:Array, current:Array}>
   *  isFirstTimeSpinning: boolean,
   *  autoStart: boolean
   * }
   * @param {Object} config
   */
  constructor(config) {
    super(game, null);
    this.wheelText = {
      style: 'font-num-blue',
      fontSize: 30,
      scaleStroke: true,
      align: 'center',
      lineSpacing: -10,
    };
    this.SpinStates = { // States for checking
      Idle: 'IDLE',
      Spinning: 'SPINNING',
      Testing: 'TESTING',
      Finished: 'FINISHED',
    };
    this.angleBetweenPins = 0;

    this.prizeList = config.prizeList;
    this.isFirstTimeSpinning = config.isFirstTimeSpinning;

    this.signals = {
      changeState: new Phaser.Signal(), // signal to change external's state when wheel finishes spinning
      collectWheelPrizeInternally: new Phaser.Signal(), // Signal for external to add the prize internally
      collectWheelPrizeVisually: new Phaser.Signal(), // Signal for external to add the prize visually (when the wheel stops)
      wheelFinished: new Phaser.Signal(), // This is really an internal signal but~
    };

    // This. variables
    this.container = undefined; // The wheel (2 levels up)
    this.display = undefined; // The wheel+pointer (1 level up)
    this.wheel = undefined; // The wheel
    this.pointer = undefined; // The pointer
    this.shine = undefined; // Shining
    this.spinSpeed = undefined;
    this.distancePassed = undefined;
    this._timeoutTimer = undefined; // The timeout timer
    this.autoStart = !(config.autoStart === undefined || config.autoStart == null) ? config.autoStart : true;
    this.checkDeadSpot = !(config.deadSpot === undefined || config.deadSpot == null) ? config.deadSpot : true;
    this.init(config);
  }

  init() {
    this.filterPrize();
    const wheelContainer = new Phaser.Group(G.Game, null); // The container that holds the wheel
    const wheelPanel = new Phaser.Group(G.Game, null); // The container that holds the wheel + pointer. Used for scaling
    const shineBurst = G.makeImage(0, 0, 'shine_godrays', 0.5, null); // Shiiiiiine
    shineBurst.update = () => {
      if (this.visible) {
        shineBurst.angle += 0.01;
        if (shineBurst.angle === 360) { shineBurst.angle = 0; }
      }
    };
    const wheelImage = this.makeWheelImage();

    this.angleBetweenPins = 360 / this.prizeList.current.length;
    this.angleGap = (this.angleBetweenPins * 0.25) / 2;

    // Make Pointer
    const pointer = G.makeImage(0, -180, 'prize_wheel_arrow', 0.5, null);
    pointer.soundTimer = 2;
    pointer.bounce = (sign) => {
      if (pointer.soundTimer < 0) {
        G.sfx.pop.play();
        pointer.soundTimer = 2;
      }
      pointer.angle = 10 * sign;
    };

    pointer.update = () => {
      if (this.visible) {
        pointer.soundTimer--;
        pointer.angle = G.lerp(pointer.angle, 0, 0.2);
      }
    };

    wheelContainer.addChild(shineBurst);
    wheelPanel.addChild(wheelImage);
    wheelPanel.addChild(pointer);
    wheelContainer.addChild(wheelPanel);
    this.addChild(wheelContainer);

    this.container = wheelContainer;
    this.display = wheelPanel;
    this.wheel = wheelImage;
    this.pointer = pointer;
    this.shine = shineBurst;
    this.spinSpeed = 0;
    this.distancePassed = 0;
  }

  filterPrize() {
    _.forEach(this.prizeList.current, (prize) => {
      if (prize.prize.indexOf('#R') > -1) {
        const processed = G.gift.processGift([prize.prize, prize.amount]);
        prize.prize = processed[0]; // eslint-disable-line prefer-destructuring
      }
    });
  }

  makeWheelImage() {
    return G.makeImage(0, 0, 'gold_wheel', 0.5, null);
  }

  /**
   * Creates the timeout timer if there isn't one
   */
  initTimeOut() {
    if (!this._timeoutTimer) {
      this._timeoutTimer = game.time.events.add(5000, () => { // After 5 sec of spinning
        if (this.game && this.spinState !== this.SpinStates.Finished) { // If we're not done
          if (Math.abs(this.spinSpeed) < 0.07 && this.getPrizeIndexFromAngle(game.math.wrapAngle(this.wheel.angle)) === -1) { // No prize determined yet
            this.spinSpeed += (Math.min(-1, Math.max(1, Math.sign(this.spinSpeed))) * 0.10); // Gives an extra burst of speed in either direction (not 0)
          } else { // Otherwise
            this.spinState = this.SpinStates.Spinning; // Start spinning already!
          }
        }
      });
    }
  }

  update() {
    if (this.container.visible) {
      // this.container.children.forEach((c) => c.update());
      if (this.spinState === this.SpinStates.Spinning && this.wheel.visible) {
        this.spinningWheel(false);
        this.initTimeOut(); // Creates a timeout timer. Doesn't create one if theres already one
      }
      this.shine.update();
      this.pointer.update();
    }
  }

  cleanUp() {
    this.container.destroy();
    this.signals.changeState.removeAll();
    this.signals.collectWheelPrizeInternally.removeAll();
    this.signals.collectWheelPrizeVisually.removeAll();
    this.signals.wheelFinished.removeAll();
  }

  destroy() {
    this.cleanUp();
    super.destroy();
  }

  /**
   * The given prizelist object as the Window_requestHelp's,
   * but this is just in case
   * @param {Object} prize
   */
  updatePrizeList(prize) {
    this.prizeList = prize;
    this.filterPrize();
  }

  /**
   * Fills the wheel with the already given prizeList
   */
  fillWheel() {
    let curAngle = 90 + this.angleBetweenPins / 2;

    if (this.labels) {
      for (let i = 0; i < this.labels.length; i++) {
        const oldLabel = this.labels[i];
        this.wheel.removeChild(this.labels[i]);
        oldLabel.destroy(true);
      }
    }

    const wheelLabels = [];
    for (let i = this.prizeList.current.length - 1; i >= 0; i--) {
      const curPrize = this.prizeList.current[i];
      const giftString = OMT_UI_DrawUtil.getGiftString(curPrize.prize); // Gets asset string
      const label = this.constructWheelText({ img: giftString, text: `${curPrize.amount}` });
      const distance = 115; // Supposed to be the height of the wheel. Centers on the wheel
      label.x = G.lengthDirX(curAngle, distance, false);
      label.y = G.lengthDirY(curAngle, distance, false);
      label.angle = curAngle + 90;
      label.prize = curPrize;

      wheelLabels.push(label);
      curAngle += this.angleBetweenPins;
    }

    for (let i = 0; i < wheelLabels.length; i++) {
      this.wheel.addChild(wheelLabels[i]);
    }

    this.labels = wheelLabels;
  }

  /**
   * Creates the image of the prize. If its a coin, it also has text with it on the bottom
   * giftData = {
   *  img: string,
   *  ?text: string
   * }
   * @param {Object} giftData
   */
  constructWheelText(giftData) {
    const isCoin = giftData.img.indexOf('coin') > -1;
    const giftBox = new Phaser.Group(G.Game, null);
    let imageName = giftData.img;
    // change booser displayed for IAP / NO IAP
    if (giftData.img === 'ui_booster_6' && !G.IAP) imageName = 'ui_booster_5';
    const giftImage = G.makeImage(0, 0, imageName, 0.5, null);

    giftImage.width = this.getIntendedDimensions(isCoin); // Coin should be bigger
    giftImage.height = giftImage.width;

    giftBox.addChild(giftImage);

    if (isCoin) { // Coin text
      const giftText = new G.Text(0, 0, giftData.text, this.wheelText, [0.5, 0]);
      // giftText.x = (giftImage.width/2);
      giftText.y = giftImage.y + giftImage.height - 35;
      giftBox.addChild(giftText);
    }

    return giftBox;
  }

  getIntendedDimensions(isCoin) {
    if (isCoin) {
      return 58.8;
    }
    return 63;
  }

  /**
   * Function for pre-determining the prize
   */
  determinePrize() {
    let sumOfProb = 0;
    const probabilities = []; // Sort and modify by the highest chance first
    for (let i = 0; i < this.prizeList.current.length; i++) {
      probabilities.push({ index: i, prize: this.prizeList.current[i] });
      sumOfProb += this.prizeList.current[i].chance;
    }
    const rng = game.math.between(0, sumOfProb); // or sum of probabilities

    if (this.isFirstTimeSpinning) { // If its the first time, rig it so +3 move or horizontal line break is picked first
      // First find out if any of those are there in the prizeList
      const firstTimeSpinPrize = this.firstTimePrize(rng, sumOfProb);
      if (firstTimeSpinPrize != null) {
        return firstTimeSpinPrize;
      }
    }
    // If they're not there do default rolling

    probabilities.sort((a, b) => {
      if (a.prize.chance < b.prize.chance) return 1;
      if (a.prize.chance >= b.prize.chance) return -1;
      return 0;
    });

    let probability = 0;
    for (let i = 0; i < probabilities.length; i++) {
      probability += probabilities[i].prize.chance;
      if (rng < probability) {
        return probabilities[i].index;
      }
    }
    return 0;
  }

  firstTimePrize(rng, total) {
    let boosterPlusThreeIndex;
    let boosterHorizontalIndex;
    for (let i = 0; i < this.prizeList.current.length; i++) {
      const curPrize = this.prizeList.current[i].prize;
      if (curPrize.indexOf('#6') > -1) {
        boosterPlusThreeIndex = i;
      }
      if (curPrize.indexOf('#3') > -1) {
        boosterHorizontalIndex = i;
      }
    }

    // If both are in
    if (boosterPlusThreeIndex !== undefined && boosterHorizontalIndex !== undefined) {
      if (rng < (total / 2)) { // pick one
        return boosterPlusThreeIndex;
      }
      return boosterHorizontalIndex;
    }
    if (boosterPlusThreeIndex !== undefined) { // If +3 move is only in
      return boosterPlusThreeIndex;
    }
    if (boosterHorizontalIndex !== undefined) { // If horizontal line break is in
      return boosterHorizontalIndex;
    }

    return null;
  }

  /**
   * Tweens the wheel in
   */
  enterTheWheel() {
    this.container.scale.x = 1;
    this.container.scale.y = 1;
    this.display.y = -game.height - this.display.height;
    this.shine.alpha = 0;
    this.container.visible = true;
    this.display.visible = true;
    this.shine.visible = true;

    const tweenTime = 500;

    const entersy = game.add.tween(this.display)
      .to({ y: 0 }, tweenTime, Phaser.Easing.Sinusoidal.In);
    entersy.onComplete.addOnce(() => {
      game.add.tween(this.shine)
        .to({ alpha: 1 }, tweenTime).start();
      if (this.autoStart) {
        this.startTheWheel();
      }
    });
    entersy.start();
  }

  /**
   * Reset angle and state of wheel
   */
  resetWheel() {
    this.wheel.angle = 0;
    this.spinState = this.SpinStates.Idle;
  }

  calculateInitialSpinSpeed() {
    this.spinSpeed = game.math.roundTo(game.rnd.between(200, 550) * 0.025, -5); // why doe?
  }

  calculateSpinSpeedAndPrize() {
    this.resetWheel();
    this.calculateInitialSpinSpeed();

    this.prizeList.predeterminedPrize = this.determinePrize();
    let giftTestSpin = 999;
    let wheelInitialSpinSpeed = this.spinSpeed;
    while (giftTestSpin !== this.prizeList.predeterminedPrize) { // Attempt to find speed to find the way to slowly turn to the end
      wheelInitialSpinSpeed += 80;
      this.wheel.angle = 0;
      this.spinSpeed = wheelInitialSpinSpeed;
      this.spinState = this.SpinStates.Testing;
      let dummyGift;
      while (dummyGift == null) { // Truly not a fan of while loops
        dummyGift = this.spinningWheel(true); // Spinning the actual wheel seems to be more accurate than an obj representation
        if (this.spinState === this.SpinStates.Finished) {
          giftTestSpin = dummyGift;
        }
      }
    }

    this.spinSpeed = wheelInitialSpinSpeed;
    this.resetWheel();
  }

  /**
   * Determine prize, find the initial spin speed that is required to get the prize
   * and then spin.
   * Initially taken from DailyWheel's wheel
   */
  startTheWheel(forcedState) {
    if (this._timeoutTimer) { // Clear the timer
      game.time.events.remove(this._timeoutTimer);
      this._timeoutTimer = null;
    }
    let fixedForceState = forcedState;
    if (!fixedForceState) {
      fixedForceState = this.SpinStates.Spinning;
    }

    const curTime = Date.now();

    this.calculateSpinSpeedAndPrize();

    // Snapshot the prize before it changes a section to coins from Internally
    const prizeSnapshot = {
      current: [],
    };
    for (let i = 0; i < this.prizeList.current.length; i++) {
      prizeSnapshot.current.push(this.prizeList.current[i]);
    }
    prizeSnapshot.predeterminedPrize = this.prizeList.predeterminedPrize;

    let timeDelay = 500; // Wait half a sec before spinning, unless that while loop above took a long time, then spin now
    if (Date.now() - curTime > timeDelay) {
      timeDelay = 1;
    }

    if (!this.signals.wheelFinished.has(this.whenWheelFinished, this)) {
      this.signals.wheelFinished.add(this.whenWheelFinished, this, 0, prizeSnapshot);
    }


    game.time.events.add(timeDelay, () => {
      this.spinTheWheel(fixedForceState);
      this.signals.collectWheelPrizeInternally.dispatch(this.prizeList);
    }, this);
  }

  whenWheelFinished(laststate, index, prizeSnapshot) {
    if (laststate !== this.SpinStates.Testing) {
      if (prizeSnapshot.predeterminedPrize !== index) { // Wheel entered a time out and landed on a wedge that was not the predetermined wedge
        console.log('Wheel time out'); // Let it be known
        prizeSnapshot.predeterminedPrize = index; // Set the landed wedge as the predetermined wedge, so it will display properly
      }
      this.signals.wheelFinished.remove(this.whenWheelFinished, this);
      this.isFirstTimeSpinning = false;
      game.time.events.add(1000, () => {
        this.signals.changeState.dispatch(true);
        this.signals.collectWheelPrizeVisually.dispatch(prizeSnapshot);
      });
    }
  }

  /**
   * Sets the state to spinning and Update will do the rest
   */
  spinTheWheel(forcedState) {
    this.spinState = forcedState;
    // Update func
  }

  checkPointerBounce(sim, spinspeed) {
    if (!sim) {
      this.pointer.bounce(Math.sign(spinspeed) * -1);
    }
  }

  /**
   * Update function for spinning the wheel.
   * If its not a simulation, the pointer will bounce and make a noise
   * @param {boolean} simulation
   */
  spinningWheel(simulation) {
    if (this.spinState === this.SpinStates.Spinning || this.spinState === this.SpinStates.Testing) {
      this.wheel.angle += this.spinSpeed;
      const prevDistancePassed = this.distancePassed;
      this.distancePassed += this.spinSpeed;
      const wheelMods = this.getWheelMods();
      if (
        Math.floor(prevDistancePassed / this.angleBetweenPins)
        !== Math.floor(this.distancePassed / this.angleBetweenPins)
      ) { // Passing a pin
        this.checkPointerBounce(simulation, this.spinSpeed);

        this.spinSpeed = game.math.roundTo(this.spinSpeed * wheelMods[0], -5); // Using roundto because I think the fpv are screwing it up
        if (this.spinSpeed < 0.25) { // Bounce back
          this.distancePassed = prevDistancePassed;
          this.spinSpeed = game.math.roundTo(this.spinSpeed * wheelMods[1], -5);
        }
      }

      this.spinSpeed = game.math.roundTo(this.spinSpeed * wheelMods[2], -5);
      if (Math.abs(this.spinSpeed) < 0.07) { // Spinning has stopped, pretty much
        const curAngle = game.math.wrapAngle(this.wheel.angle);
        const giftIndex = this.getPrizeIndexFromAngle(curAngle);
        if (giftIndex > -1) {
          this.wheelFinished(this, giftIndex);
          return giftIndex;
        }
        if (this.spinSpeed < 0) {
          this.spinSpeed += this.spinSpeed;
        }
      }
    }
    return null;
  }

  /**
   * Returns an array of numbers that are used to modify how the wheel spins.
   * @returns Array<number>
   */
  getWheelMods() {
    return [
      0.93,
      -0.5,
      0.965,
    ];
  }

  /**
   * The wheel has stopped spinning
   * @param {Object} wheelPack
   * @param {number} giftIndex
   */
  wheelFinished(wheelPack, giftIndex) {
    const lastState = wheelPack.spinState;
    // eslint-disable-next-line no-param-reassign
    wheelPack.spinState = this.SpinStates.Finished;
    this.signals.wheelFinished.dispatch(lastState, giftIndex);
  }

  /**
   * Determines the prize from the angle.
   * I don't quite get it.
   * @param {number} angle
   * @param {boolean} checkDeadSpot Check the dead spot or not
   * @returns {number} prize index
   */
  getPrizeIndexFromAngle(angle, checkDeadSpot = true) {
    const angleToDisplay = angle + 180; // Bump angle from (-180, 180) to (0, 360)

    const prize = Math.floor(angleToDisplay / this.angleBetweenPins); // Determine prize
    let isGoodToGo = true;
    if (checkDeadSpot) {
      isGoodToGo = this.isWithinDeadSpot(angleToDisplay, prize); // Is it in the pin gap or not?
    }
    if (isGoodToGo) {
      return prize;
    }
    return -1; // Don't return as prize if its in the pin gap
  }

  /**
   * Checks the angle if it's within a dead spot
   * @param {number} angleToDisplay
   * @param {number} prize
   * @returns {boolean}
   */
  isWithinDeadSpot(angleToDisplay, prize) {
    if (!this.checkDeadSpot) {
      return true;
    }
    let nextAngle = this.angleBetweenPins * (prize + 1); // Find the angle to the next pin
    if (nextAngle > 360) { // Bump it higher (to like (180, 520)) to avoid wrapping
      angleToDisplay += 180;
      nextAngle += 180;
    }
    /**
     *             \ \    / / Outer edges are the pin gap
     *              \ \  / /
     *               \ || /
     *                \||/
     * 360 degress <-- \/ --> 0 degrees
     */
    // Also recalculate pin angle because the nextAngle check modifies it to avoid wrapping
    const deadStart = (Math.floor(angleToDisplay / this.angleBetweenPins) * this.angleBetweenPins) + this.angleGap; // Check that its not inside of a pin gap (closer)
    const deadEnd = nextAngle - this.angleGap; // Check that its not inside of a pin gap (farther)
    return angleToDisplay > deadStart && angleToDisplay < deadEnd; // Is angle outside of the dead areas?
  }
}
